export const EVENT_STREAM_TYPE = '54206922-016c-4f3a-8eec-43e676a39c1c';
//# sourceMappingURL=EventStream.js.map